export default "__VITE_ASSET__3d73d93e__"